<template>
  <div class="contents">
    <div class="d-flex section-title-with-back" v-if="id">
      <img src="@/assets/images/Icon awesome-pen.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">クラス編集</p>
    </div>
    <div class="d-flex section-title-with-back" v-else>
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">クラス登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'class-id-edit' : 'class-add', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">以下の内容で登録しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">教場名（教場ID）</th>
            <td>{{ currentSchoolDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名（コースID）</th>
            <td>{{ currentCourseDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">クラス名</th>
            <td>{{ displayTamaiClass.name }}</td>
          </tr>
          <tr>
            <th scope="row">クラス名フリガナ</th>
            <td>{{ displayTamaiClass.nameReading }}</td>
          </tr>
          <tr v-if="id">
            <th scope="row">クラスID（自動生成）</th>
            <td>{{ displayTamaiClass.uid }}</td>
          </tr>
          <tr>
            <th scope="row">先生名（担当・メイン）</th>
            <td>{{ currentMainTeacherDisplay }}</td>
          </tr>
          <tr v-for="index in maxNumOfTeacher" :key="index">
            <template v-if="currentTamaiClassTeacherDisplay(index)">
              <th scope="row">先生名（担当・サブ{{ index }}）</th>
              <td>{{ currentTamaiClassTeacherDisplay(index) }}</td>
            </template>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
        <button type="button" class="btn-red" @click="confirmSaved" :disabled="isLoading">登録</button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="一覧に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header v-if="id">クラス編集</template>
        <template v-slot:header v-else>クラス登録</template>
        <template v-slot:body v-if="id">クラスの登録情報の編集が完了しました！</template>
        <template v-slot:body v-else>クラス登録が完了しました！</template>
      </PopUpHolder>
      <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
} from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    PopUpHolder,
  },
  data() {
    return {
      displayTamaiClass: null,
      errorMessage: null,
      isLoading: false,
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      if (store.getters['tamai_class/existsUpdateRequiredParams']) {
        store.dispatch('tamai_class/fetchTamaiClass', routeTo.params.id).then(() => {
          next();
        });
      } else {
        next({ name: 'class-id-edit', params: { id: routeTo.params.id } });
      }
    } else {
      if (store.getters['tamai_class/existsRegistrationRequiredParams']) {
        next();
      } else {
        next({ name: 'class-add' });
      }
    }
  },
  created() {
    // クラス情報を表示用に格納
    if (this.tamai_class.editingTamaiClass) {
      this.displayTamaiClass = this.tamai_class.editingTamaiClass;
    } else {
      this.displayTamaiClass = this.tamai_class.tamaiClass;
    }
  },
  computed: {
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.displayTamaiClass.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.displayTamaiClass.brand);
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.displayTamaiClass.school);
    },
    currentCourseDisplay() {
      return basicCourseNameIdPresent(this.displayTamaiClass.course);
    },
    currentMainTeacherDisplay() {
      if (this.displayTamaiClass.mainTeacher) {
        return this.displayTamaiClass.mainTeacher.name;
      }
      return '';
    },
    ...mapState(['tamai_class']),
    ...mapGetters('tamai_class', ['maxNumOfTeacher']),
  },
  methods: {
    currentTamaiClassTeacherDisplay(index) {
      let teacher = this.displayTamaiClass['teacher' + index];
      if (teacher && teacher.id) {
        return teacher.name;
      }
      return null;
    },
    confirmRevised() {
      if (this.id) {
        // This path is for Editing existing Class flow
        this.$logger.debug('Need revise, go back to ID ' + this.id);
        this.$router.push({ name: 'class-id-edit', params: { id: this.id } });
      } else {
        // This path is for Adding new Class flow
        this.$logger.debug('Need revise, go back');
        this.$router.push({ name: 'class-add' });
      }
    },
    confirmSaved() {
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.displayTamaiClass));
      if (this.id) {
        // This path is for Editing existing Class flow
        this.finishEditingTamaiClass(this.id).then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      } else {
        this.isLoading = true;
        // This path is for Adding new Class flow
        this.finishEditingTamaiClass().then(
          (response) => {
            this.$logger.debug('Show success popup ' + response);
            this.$refs['popup_holder'].show();
          },
          (error) => {
            this.isLoading = false;
            this.errorMessage = error;
            this.$logger.debug('Error ' + error);
          }
        );
      }
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'class' });
    },
    ...mapActions('tamai_class', ['finishEditingTamaiClass']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
